import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
// import { createSite } from 'redux/modules/model/site'
import { listClients } from 'redux/modules/model/client'
import { clientsSelector } from 'redux/selectors'
import { DetectablesForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import { getImageData } from 'utils/helpers';
import { wsClient } from 'index';
import { Typography, Table, Tag, Button, notification } from '@/elements';
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class DetectableAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    // createSite: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients } = this.props
    listClients({ clientId })
  }

  handleSubmit = (values) => {
    const fileReader = new FileReader();

    if (fileReader && values.file && values.file.file) {
      fileReader.readAsArrayBuffer(values.file.file);
      fileReader.onload = async () => {
        let requestPayload = {}
        if(values.type === "Detectables") {
          requestPayload = {
            "messageType": "core.detectable.upload-file",
            "payload": {
              "clientId": values.clientId,
              "fileStream": getImageData(fileReader.result),
            }
          }
        } else if(values.type === "Holder") {
          requestPayload = {
            "messageType": "core.detectable.upload-file-names",
            "payload": {
              "clientId": values.clientId,
              "fileStream": getImageData(fileReader.result),
            }
          }
        }
        
        console.log("🚀 ~ file: index.js ~ line 51 ~ DetectableAdd ~ fileReader.onload= ~ requestPayload", requestPayload)

        const response = await wsClient.request(requestPayload);
        console.log("🚀 ~ file: index.js ~ line 54 ~ DetectableAdd ~ fileReader.onload= ~ response", response)
        const messageType = get(response, 'messageType', '');
        console.log("🚀 ~ file: index.js ~ line 54 ~ DetectableAdd ~ fileReader.onload= ~ messageType", messageType)
        const errorMessage = get(response, 'payload.message', 'Ooops! Something went wrong with the file.');

        // setSubmiting(false);

        if (messageType === 'core.error.invalid-parameter-format') {
          return notification.error({
            message: 'Error',
            description: errorMessage,
            placement: 'bottomLeft',
          });
        }

        if (messageType === 'core.error.not-found') {
          return notification.error({
            message: 'Error',
            description: errorMessage,
            placement: 'bottomLeft',
          });
        }

        if (messageType === 'core.detectable.upload-file-result') {
          return notification.success({
            message: 'Success',
            description: 'Successfully imported detectables',
            placement: 'bottomLeft',
          });
        }

        return notification.error({
          message: 'Error',
          description: errorMessage,
          placement: 'bottomLeft',
        });
      };
    }
  };

  // handleSubmit = (values) => {
  //   // const { clientId, history, createSite } = this.props
  //   // return formSubmit(createSite, { ...values })
  //   //   .then(() => history.push(ROUTES.DETECTABLE))
  // };

  render() {
    const { clientList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.DETECTABLE}>&laquo; Back</Link></p>
          <PageContentTitle>Add detectables</PageContentTitle>
          <DetectablesForm onSubmit={this.handleSubmit} clients={clientList} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector
})

export const actions = {
  // createSite,
  listClients
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(DetectableAdd)



// WEBPACK FOOTER //
// ./src/pages/detectable/detectable-add/index.js